import React, { ReactNode } from 'react';
import MaterialCarousel from 'react-material-ui-carousel';
import Carousel, { ArrowProps, DotProps } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Typography from '../../../../components/Typography';

interface ICards {
  title: string;
  text: string;
  ctaText: string;
  onCta: () => void;
  ctaIcon?: ReactNode;
  link?: string;
  lessThanMd?: boolean;
  isActive?: boolean;
  addSpace?: boolean;
  className?: string;
  backGroundImage?: string;
}

const Cards = ({
  title,
  text,
  ctaText,
  onCta,
  ctaIcon,
  link,
  lessThanMd,
  isActive,
  className,
  backGroundImage,
}: ICards) => {
  return (
    <div
      style={{
        margin: '0 10px',
        willChange: 'transform',
        transform: 'translate3d(0, 0, 0)',
      }}
      className={`tw-bg-[#1D084F] tw-text-white tw-flex tw-flex-col tw-flex-1 tw-gap-2 tw-rounded-[8px] tw-h[154px]  tw-min-h-[154px] tw-p-4 tw-overflow-hidden ${className} ${
        lessThanMd ? 'tw-w-full' : 'tw-min-w-[309px]'
      } `}
    >
      {backGroundImage && (
        <div className="tw-absolute tw-top-0 tw-left-0 tw-h[154px]  tw-min-h-[154px] tw-w-full tw-z-[-10] ">
          <img alt="background" src={backGroundImage} className="tw-h[154px]  tw-min-h-[154px] tw-w-full " />
          <div className="tw-absolute tw-inset-0 tw-bg-[#150036] tw-bg-opacity-5" />
        </div>
      )}
      <Typography className="tw-text-[20px]" variant="subtitle1">
        {title}
      </Typography>
      <Typography className="tw-text-[#EAEAFD] tw-text-sm">{text}</Typography>

      {!link && (
        <div className="tw-mt-auto">
          <button
            className={`tw-mt-auto tw-cursor-pointer 
            tw-flex tw-flex-row tw-items-center tw-gap-1 
            tw-text-[#FB9D0E] 
            tw-border-none tw-p-0 tw-font-bold tw-text-sm
            ${isActive ? 'tw-text-white tw-rounded-md tw-p-1 tw-bg-[#FB9D0E]' : 'tw-text-[#FB9D0E] tw-bg-transparent'}`}
            onClick={onCta}
            type="button"
          >
            <Typography> {ctaText}</Typography>
            {ctaIcon}
          </button>
        </div>
      )}

      {link && (
        <Link
          to={link}
          className="tw-mt-auto tw-cursor-pointer tw-flex tw-flex-row tw-items-center tw-gap-1 tw-text-[#FB9D0E] tw-bg-transparent tw-border-none tw-p-0 tw-font-bold tw-text-sm tw-no-underline"
        >
          <Typography> {ctaText}</Typography>
          {ctaIcon}
        </Link>
      )}
    </div>
  );
};

const CustomRightArrow = ({ onClick }: ArrowProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="tw-absolute tw-right-[20px] tw-bottom-[12px] tw-w-[28px] tw-h-[28px] tw-z-10 tw-bg-[#CACBFB] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-opacity-100 tw-transition-none tw-focus:outline-none"
      style={{
        border: 'none',
        cursor: 'pointer',
      }}
    >
      <ArrowForwardIosIcon sx={{ color: '#3a2a57' }} className="tw-w-[15px] tw-h-[15px]" />
    </button>
  );
};

const CustomDot = ({ onClick, active, index }: DotProps) => {
  return (
    <div className="tw-mx-[2px]">
      <button
        type="button"
        onClick={onClick}
        className={`tw-cursor-pointer tw-p-0 !tw-max-w-[10px]  !tw-min-w-[10px]  !tw-w-[10px]  tw-max-h-[10px] tw-min-h-[10px] tw-h-[10px] tw-border-none tw-outline-none tw-rounded-[1000px] tw-transition-all tw-duration-300 ${
          active ? 'tw-bg-[#1D084F]' : 'tw-bg-gray-300'
        }`}
        aria-label={`Go to slide ${(index ?? 0) + 1}`}
      />
    </div>
  );
};

interface IDiscoverCards {
  cards: ICards[];
}

const DiscoverCards = ({ cards }: IDiscoverCards) => {
  const theme = useTheme();
  const lessThanMd = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
  if (lessThanMd) {
    return (
      <div className="tw-flex tw-flex-row  tw-w-full tw-items-center tw-justify-center ">
        <MaterialCarousel
          className="tw-w-full "
          autoPlay={false}
          navButtonsAlwaysVisible
          NavButton={({ onClick, prev }) => {
            if (prev) return null;
            return (
              <button
                type="button"
                onClick={() => onClick()}
                className="tw-bg-[#CACBFB] tw-flex tw-justify-center tw-items-center tw-mt-[107px] tw-mr-[12px] tw-w-[28px] tw-h-[28px] tw-rounded-full tw-opacity-100 tw-transition-none tw-focus:outline-none"
                style={{
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <ArrowForwardIosIcon sx={{ color: '#3a2a57' }} className="tw-w-[15px] tw-h-[15px]" />
              </button>
            );
          }}
        >
          {cards.map((x, i) => (
            <Cards lessThanMd={lessThanMd} key={i} {...x} />
          ))}
        </MaterialCarousel>
      </div>
    );
  }
  return (
    <div className="tw-min-h-[156px]  tw-w-full tw-bg-white tw-relative tw-pb-10">
      <Carousel
        transitionDuration={300}
        additionalTransfrom={0}
        arrows // here
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<div />}
        autoPlaySpeed={3000}
        centerMode={false}
        className="tw-mx-[15px]"
        containerClass="container"
        draggable // here
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1375,
            },
            items: 4,
          },
          tablet: {
            breakpoint: {
              max: 1375,
              min: 1105,
            },
            items: 3,
            partialVisibilityGutter: 30,
          },
          mobile: {
            breakpoint: {
              max: 1105,
              min: 0,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots // here
        renderDotsOutside
        customDot={<CustomDot />}
        dotListClass=""
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {cards.map((x, index) => {
          return <Cards lessThanMd={lessThanMd} key={index} {...x} />;
        })}
      </Carousel>
    </div>
  );
};

export default DiscoverCards;
